const { TRIAL_TARIFF_DAYS_DURATION } = require('../appConstants');
const {
    lite2024CommonName,
    professional2024CommonName,
    expert2024CommonName,
    ultimate2025CommonName,
} = require('./common-book-tariffs');

module.exports = {
    ULTIMATE_2025: {
        name: ultimate2025CommonName,
        description: `Die perfekte Wahl, wenn Sie etwas Einzigartiges möchten und Zenamu ohne jegliche Einschränkungen nutzen möchten`,
    },
    EXPERT_2024: {
        name: expert2024CommonName,
        description: `Ich bin ein unabhängiger Experte oder ein Studio mit einem Team von zwei oder mehr Lehrern. Unser Angebot umfasst eine breite Palette von offenen Klassen, speziellen Workshops und regelmäßigen thematischen geschlossenen Kursen.`,
    },
    PROFESSIONAL_2024: {
        name: professional2024CommonName,
        description: `Ich habe ein etabliertes Geschäft und treue Kunden, die immer wieder zu mir zurückkehren. Ich biete mehrere offene Klassen pro Woche und langfristige geschlossene Kurse mit mehreren Lektionen an.`,
    },
    LITE_2024: {
        name: lite2024CommonName,
        description: `Ich biete regelmäßig wöchentliche offene Klassen an und organisiere gelegentlich spezialisierte Wochenend-Workshops. Meine Kurse sind für regelmäßige Teilnehmer gedacht.`,
    },
    TRIAL_FREELANCER: {
        name: `Testversion mit unbegrenzten Funktionen`,
        description: `Mit einer neuen Registrierung kannst du das Abonnement für Einzeltrainer ${TRIAL_TARIFF_DAYS_DURATION} Tage lang kostenlos testen.`,
    },
    TRIAL_STUDIO: {
        name: `Testversion mit unbegrenzten Funktionen`,
        description: `Mit einer neuen Registrierung kannst du das "Studio"-Abonnement ${TRIAL_TARIFF_DAYS_DURATION} Tage lang kostenlos testen.`,
    },
    FREE: {
        name: `Erste Schritte`,
        description: `Ich plane Kurse unregelmäßig und eher gelegentlich. Ich biete nur wenige Kurse pro Monat für eine kleine Gruppe interessierter Personen an.`,
    },
    FREELANCER_2024_COMPATIBILITY: {
        name: 'Profi',
        description: `Ich bin ein Lehrer. Ich biete offene Kurse, Workshops oder Seminare an.`,
    },
    STUDIO_2024_COMPATIBILITY: {
        name: 'Studio',
        description: `Wir veranstalten Kurse, offene Stunden oder Workshops, die von verschiedenen Lehrern geleitet werden.`,
    },
    STUDIO_PRO_2024_COMPATIBILITY: {
        name: 'Studio PRO',
        description: `Wir veranstalten Kurse, offene Stunden oder Workshops, die von verschiedenen Lehrern geleitet werden.`,
    },
};
